import { goalbookUrls } from '@/links'

export async function getDisabilitiesAndImpactAreas(licenseSubType, contentProfile) {
  let options = {
    license_sub_type: licenseSubType,
    content_profile: contentProfile,
  }
  const params = new URLSearchParams(options)
  const response = await fetch(
    `${
      goalbookUrls.presentlevels
    }/presentlevels/api/v1/impact-of-disability/disabilities?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }
  )
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON,
  }
}

export async function getIODStatementsByImpactArea(disabilityUuid, contentProfile) {
  let options = {
    disability: disabilityUuid,
    content_profile: contentProfile,
  }
  const params = new URLSearchParams(options)
  const response = await fetch(
    `${
      goalbookUrls.presentlevels
    }/presentlevels/api/v1/impact-of-disability/statements?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }
  )
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON,
  }
}
